<template>
  <div v-if="userLoading" class="table-group">
    <div class="table-loader"></div>
  </div>
  <div v-if="userError" class="mc-error">{{ userError }}</div>
<template v-if="userLoaded">
  <div class="header-wrapper txt-center">
    <div class="h1">{{ user.fio }}</div>
    <div class="label txt-upper">
      <span class="font-13">{{ user.role_name }}</span>
    </div>
  </div>
  <!--info list-->
  <div class="profile-card light-bg">
    <ul class="profile-card-list">
      <li class="profile-card-item" v-if="user.login">
        <p class="font-14">{{ $t('profile.login') }}</p>
        <p class="font-15">{{ user.login }}</p>
      </li>
      <li class="profile-card-item" v-if="user.email_personal">
        <p class="font-14">{{ $t('profile.personalEmail') }}</p>
        <p class="font-15">{{ user.email_personal }}</p>
      </li>
      <li class="profile-card-item" v-if="user.email_group">
        <p class="font-14">{{ $t('profile.groupEmail') }}</p>
        <p class="font-15">{{ user.email_group }}</p>
      </li>
      <li class="profile-card-item" v-if="user.phone">
        <p class="font-14">{{ $t('profile.phone') }}</p>
        <p class="font-15">{{ user.phone }}</p>
      </li>
      <li class="profile-card-item" v-if="user.company">
        <p class="font-14">{{ $t('profile.company') }}</p>
        <p class="font-15">{{ user.company }}</p>
      </li>
      <li class="profile-card-item" v-if="user.code">
        <p class="font-14">{{ $t('profile.code') }}</p>
        <p class="font-15">{{ user.code }}</p>
      </li>
      <li class="profile-card-item" v-if="user.inn">
        <p class="font-14">{{ $t('profile.inn') }}</p>
        <p class="font-15">{{ user.inn }}</p>
      </li>
      <li class="profile-card-item" v-if="user.address_fact">
        <p class="font-14">{{ $t('profile.actualAddress') }}</p>
        <p class="font-15">{{ user.address_fact }}</p>
      </li>
      <li class="profile-card-item" v-if="user.address_legal">
        <p class="font-14">{{ $t('profile.legalAddress') }}</p>
        <p class="font-15">{{ user.address_legal }}</p>
      </li>
      <li class="profile-card-item" v-if="user.fio_boss">
        <p class="font-14">{{ $t('profile.bossName') }}</p>
        <p class="font-15">{{ user.fio_boss }}</p>
      </li>
      <li class="profile-card-item" v-if="user.comment">
        <p class="font-14">{{ $t('profile.comment') }}</p>
        <p class="font-15">{{ user.comment }}</p>
      </li>
      <li class="profile-card-item" v-if="user.storages && user.storages.length">
        <p class="font-14">{{ $t('profile.storages') }}</p>
        <p class="font-15">{{ userStorages.join(", ") }}</p>
      </li>
      <li class="profile-card-item" v-if="user.suppliers && user.suppliers.length">
        <p class="font-14">{{ $t('profile.suppliers') }}</p>
        <p class="font-15">{{userSuppliers.join(", ")}} </p>
      </li>
    </ul>
    <div class="flex-center mt-15">
      <router-link v-if="profile.role === 'admin'" :to="{ name: 'user-edit', params: { id: user.id } }" class="btn">{{ $t('profile.edit') }}</router-link>
    </div>
  </div>
</template>
</template>

<script>
import UserForm from '@/components/form/UserForm.vue';
import {mapActions, mapGetters} from "vuex";

export default {
  components: {
    UserForm,
  },
  created() {
    if (this.profile.role !== 'admin' && this.profile.id != this.$route.params.id)
      this.$router.push('/');
    this.fetchUser(this.$route.params.id);
  },
  computed: {
    ...mapGetters('user', [
      'user',
      'userLoading',
      'userError',
      'userLoaded',
    ]),
    ...mapGetters('app', [
      'roleOptions',
      'supplierOptions'
    ]),
    ...mapGetters({
      profile: 'user'
    }),
    suppliers() {
      let result = {};
      this.supplierOptions.forEach(supplier => {
        result[parseInt(supplier.value)] = supplier.label;
      })
      return result;
    },
    userSuppliers() {
      let result = [];
      if (this.user.suppliers) {
        this.user.suppliers.forEach(supplier => {
          result.push(this.suppliers[supplier]);
        })
      }
      return result;
    },
    userStorages() {
      let result = [];
      if (this.user.storages) {
        this.user.storages.forEach(storage => {
          result.push(storage.value);
        })
      }
      return result;
    }
  },
  methods: {
    ...mapActions('user', [
      'fetchUser',
    ]),

  }
}
</script>
